export const ItemTypes = {
  WINDOW: "WINDOW",
};
